import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { SettlementUser } from 'src/app/models/settlement-user.model';
import { ToastrService } from 'ngx-toastr';
import { IconsService } from 'src/app/shared/services/icons.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Settlement } from 'src/app/models/settlement.model';
import { UsersFormComponent } from './users-form.component';

@Component({
  selector: 'app-users-list',
  template: `
    <div class="list-group-item py-3">
      <div class="d-flex">
        <h5>Usuarios del Condominio</h5>
        <div class="ms-auto">
          <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openUserModal()">
            <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon> Agregar usuario
          </button>
        </div>
      </div>
      <div class="mt-3" *ngIf="!loading">
        <table class="table table-sm table-striped">
          <thead>
            <tr>              
              <th>Nombre</th>
              <th>Email</th>
              <th>Teléfono</th>
              <th>Rol</th>
              <th class="text-center">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of users">              
              <td>{{ user.name }} {{ user.last_name }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.phone || '-' }}</td>
              <td>
                <span class="badge" [ngClass]="{
                  'bg-primary': user.role.name === 'settlement_admin',
                  'bg-success': user.role.name === 'settlement_operation',
                  'bg-info': user.role.name === 'settlement_billing'
                }">
                  {{ getRoleName(user.role.name) }}
                </span>
              </td>
              <td class="text-center">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-link text-info p-0 me-3" (click)="openUserModal(user)">
                    <fa-icon [icon]="icons.faEdit"></fa-icon>
                  </button>
                  <button class="btn btn-link text-danger p-0" (click)="deleteUser(user)">
                    <fa-icon [icon]="icons.faTrashAlt"></fa-icon>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <p class="text-muted text-center my-3" *ngIf="users && users?.length === 0">No hay usuarios registrados para este condominio.</p>
      </div>
      <div class="text-center my-5" *ngIf="loading">
        <fa-icon [icon]="icons.faCircleNotch" size="3x" animation="spin" class="text-secondary"></fa-icon>
        <p class="text-muted mt-2">Cargando usuarios...</p>
      </div>
    </div>
    <app-users-form
      [settlement]="settlement"
      [user]="selectedUser"
      (formSubmitted)="onUserSaved($event)"
    ></app-users-form>
  `,
  styles: ``
})
export class UsersListComponent {
  @Input() settlement: Settlement | null = null;
  @ViewChild(UsersFormComponent, { static: true }) usersFormComponent !: UsersFormComponent;
  
  users: SettlementUser[] = [];
  loading: boolean = true;
  selectedUser: SettlementUser | null = null;

  constructor(
    private store: SettlementsService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public icons: IconsService
  ) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['settlement'] && changes['settlement'].currentValue) {
      this.loadUsers();
    }
  }

  loadUsers(): void {
    this.loading = true;
    this.store.getSettlementUsers(Number(this.settlement?.id)).subscribe({
      next: (data: any) => {
        this.users = data || [];
        this.loading = false;
      },
      error: (error: any) => {
        this.toastr.error('Error al cargar usuarios', 'Error');
        this.loading = false;
      }
    });
  }

  openUserModal(user: SettlementUser | null = null, modal: any = null): void {
    this.selectedUser = user;
    const modalTemplate: any = this.usersFormComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['usersForm']);
    }
  }

  deleteUser(user: SettlementUser): void {
    if (confirm(`Está seguro que desea eliminar el usuario ${user.email}?`)) {
      this.store.deleteSettlementUser(Number(this.settlement?.id), user.id!).subscribe({
        next: () => {
          this.toastr.success('Usuario eliminado correctamente', 'Éxito');
          this.loadUsers();
        },
        error: (error) => {
          this.toastr.error('Error al eliminar usuario', 'Error');
        }
      });
    }
  }

  onUserSaved(success: boolean): void {
    if (success) {
      this.modalService.dismissAll();
      this.loadUsers();
      this.selectedUser = null;
    }
  }

  getRoleName(role: string): string {
    switch(role) {
      case 'settlement_admin': return 'Administrador';
      case 'settlement_operation': return 'Operación';
      case 'settlement_billing': return 'Facturación';
      default: return role;
    }
  }
}
